<template>

<div class="list-view logbooks-list">

	<div class="sub-header with-sort">
		<div v-if="auditMode" class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Scan or enter serial number..." @search="doAudit()" v-focus>
			<div class="button action input-go" @click="doAudit()"><i class="fas fa-search"></i></div>
			<div class="search-message" v-html="auditMessage" style="width: 30em; position: absolute; top: 0; right: -31em; font-size: 1.25em;"></div>
		</div>
		<div v-else class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="doSearch()" v-focus>
			<div class="button action input-go" @click="doSearch()"><i class="fas fa-search"></i></div>
			<!-- <label style="position: absolute; left: 102%; top: 0.5em; width: 30em;">Search here for a serial number, sequence number, receipt or disposition name or address, product UPC or model.</label> -->
		</div>
		<div class="controls-sort" @change="doSearchSelect()">
			<label v-if="!auditMode" for="">Search By</label>
			<select v-if="!auditMode" v-model="filters.search_select" name="" id="">
				<option value="">All</option>
				<option value="serial_number">Serial Number</option>
				<option value="disposition_name">Disposition Name</option>
				<option value="sequence_number">Sequence Number</option>
				<option value="receipt_name">Receipt Name</option>
				<option value="model">Model</option>
				<option value="manufacturer">Manufacturer</option>
				<option value="importer">Importer</option>
				<option value="upc">UPC</option>
			</select>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			<button v-if="showDetail && entry.is_disposed" :class="loading ? 'disabled' : 'neutral'" style="margin: 0 1em 0 0;" @click="doPrint()">Print Disposition Receipt</button>
			<button v-if="showDetail" class="neutral" @click="backToList()">Back To List</button>
		</div>
	</div>

	<div class="filters" v-if="showFilters">

		<template v-if="!auditMode">

			<div v-if="clientFFLNumbers.length > 0">
				<div class="title">FFL Number...</div>
				<select v-model="filters.client_ffl_number_id" @change="getControlLists()">
					<option v-for="(clientFFLNumber, index) in clientFFLNumbers" :key="index" :value="clientFFLNumber.client_ffl_number_id">{{ clientFFLNumber.ffl_number }}</option>
				</select>
				<div class="divider"></div>
			</div>

			<div class="title">Filter by logbook...</div>
			<ul class="checkbox-group">
				<li v-for="(logbook, index) in getLogbooks" :key="index">
					<span :class="['pointer', 'far', logbookInFilter(logbook.ffl_log_book_id) ? 'fa-check-square' : 'fa-square']" @click="setLogbookFilter(logbook.ffl_log_book_id)"></span>
					<label>{{ logbook.ffl_log_book_code }} - {{ logbook.description }}</label>
				</li>
			</ul>

			<div class="divider"></div>
			<div class="title">Filter by status...</div>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.on_hand ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('on_hand')"></span>
					<label>On Hand</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.disposed ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('disposed')"></span>
					<label>Disposed</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.is_new ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('is_new')"></span>
					<label>New</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.is_used ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('is_used')"></span>
					<label>Used</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.moved_from ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('moved_from')"></span>
					<label>Moved</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.not_inventory ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('not_inventory')"></span>
					<label>On Hand, Not Inventory</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.has_sales_info ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('has_sales_info')"></span>
					<label>On Hand, Has Sales Info</label>
				</li>
			</ul>

			<div class="divider"></div>
			<div class="title">Filter by data...</div>
			<div>
				<div class="input-with-control">
					<input type="text" v-model="filters.manufacturer" placeholder="Manufacturer" @keyup.enter="getFilterList('manufacturer')">
					<div class="button action input-go" @click="getFilterList('manufacturer')"><i class="fas fa-search"></i></div>
				</div>
				<div class="input-with-control">
					<input type="text" v-model="filters.originator_contact" placeholder="Received From" @keyup.enter="getFilterList('originator_contact')">
					<div class="button action input-go" @click="getFilterList('originator_contact')"><i class="fas fa-search"></i></div>
				</div>
				<div class="input-with-control">
					<input type="text" v-model="filters.disposal_contact" placeholder="Disposed To" @keyup.enter="getFilterList('disposal_contact')">
					<div class="button action input-go" @click="getFilterList('disposal_contact')"><i class="fas fa-search"></i></div>
				</div>
				<select v-model="filters.gun_type" @change="getList()">
					<option value="">Type</option>
					<option v-for="gun_type in gun_types" :value="gun_type">{{ gun_type }}</option>
				</select>
			</div>

			<div class="divider"></div>
			<div class="title">Filter by dates...</div>
			<div>
				<div class="label-group">
					<label>Start</label>
					<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
				</div>
				<div class="label-group">
					<label>End</label>
					<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
				</div>
				<div class="label-group">
					<label></label>
					<div class="checkbox-group">
						<span :class="['pointer', 'far', !filters.start_date && !filters.end_date ? 'disabled' : '', filters.use_date_received ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('use_date_received')"></span>
						<label>Received</label>
						<span :class="['pointer', 'far', !filters.start_date && !filters.end_date ? 'disabled' : '', filters.use_date_disposed ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('use_date_disposed')"></span>
						<label>Disposed</label>
					</div>
				</div>
				<div class="label-group">
					<label></label>
					<div class="button small neutral" @click="setFilterDates()">Filter Dates</div>
				</div>
			</div>

			<div class="divider"></div>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.include_moved ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('include_moved')"></span>
					<label>Include original moved records</label>
					<div class="note" style="margin: 0.5em 0 0 0;">NOTE: original moved records are now excluded by default. Check this box to include original moved records.</div>
				</li>
			</ul>

			<div class="divider"></div>

			<div class="title">List Legend</div>
			<div style="display: grid; grid-template-columns: 18px 1fr; grid-gap: 0.5em; font-size: 0.8em;">
				<div v-if="filters.include_moved" style="background-color: #f4f4f4;"></div><div v-if="filters.include_moved">Moved <i class="fas fa-arrow-right" style="color: #666; padding: 0 0 0 0.5em;"></i></div>
				<div style="background-color: grey;"></div><div>Disposed <i class="fas fa-lock" style="color: #666; padding: 0 0 0 0.5em;"></i></div>
				<div style="background-color: green;"></div><div>On Hand</div>
				<div style="background-color: #F5B041;"></div><div>On Hand, Has Sales Info</div>
				<div v-if="hasNonInventory" style="background-color: blue;"></div><div v-if="hasNonInventory" >On Hand, Not Inventory <i class="fas fa-box" style="color: #666; padding: 0 0 0 0.5em;"></i></div>
			</div>

			<div class="divider"></div>
			<div :class="['button', hasFilters() ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear Filters</div>
			<div :class="['button', list.length > 0 ? 'neutral' : 'disabled']" @click="exportList()">Export CSV</div>
			<div :class="['button', list.length > 0 ? 'neutral' : 'disabled']" @click="showPrintModal = true">Print List</div>
			<div v-if="filterLoading" class="message"><i class="fa fa-spinner fa-spin" /></div>
			<div v-if="filterMessage" class="message" v-html="filterMessage"></div>

			<div class="divider"></div>
			<div class="button primary action" @click="setAuditMode()">
				Audit Mode
				<tool-tip left='-17' content='Audit mode allows you to scan your floor inventory and record an audit date for each on-hand serial number.'/>
			</div>


		</template>

		<template v-if="auditMode">
			<h3>Audit Mode</h3>

			<div class="label-group">
				<label>Date</label>
				<input type="date" v-model="filters.audit_date" :max="$today().clone().format('YYYY-MM-DD')" @change="setLogbookFilter(false,true)">
			</div>

			<div class="divider"></div>

			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.log_books.length == 0 ? 'fa-check-square' : 'fa-square']" @click="setLogbookFilter(false,true)"></span>
					<label>All Books</label>
				</li>
				<li v-for="(logbook, index) in getLogbooks" :key="index">
					<span :class="['pointer', 'far', logbookInFilter(logbook.ffl_log_book_id) ? 'fa-check-square' : 'fa-square']" @click="setLogbookFilter(logbook.ffl_log_book_id)"></span>
					<label>{{ logbook.ffl_log_book_code }} - {{ logbook.description }}</label>
				</li>
			</ul>

			<div class="divider"></div>

			<div :class="['filter-list-button', filters.audited ? 'active' : '']" @click="toggleFilter('audited')"><div class="filter-count">{{ auditCount.audited }}</div>audited on this date.</div>
			<div :class="['filter-list-button', !filters.audited ? 'active' : '']" @click="toggleFilter('audited')"><div class="filter-count">{{ auditCount.not_audited }}</div>remaining to be audited.</div>

			<div class="divider"></div>

			<div>
				<div :class="['button', list.length > 0 ? 'neutral' : 'disabled']" @click="exportList()">Export CSV</div>
				<div :class="['button', list.length > 0 ? 'neutral' : 'disabled']" @click="showPrintModal = true">Print List</div>
			</div>

			<div class="divider"></div>
			<div class="button primary action" @click="setSearchMode">
				Search Mode
				<tool-tip left='-17' content='You are currently in Audit Mode. Search Mode allows you to search and filter all of your log book records.'/>
			</div>

		</template>

	</div>

	<logbook-entry-detail v-if="showDetail" :entry="entry" @cancel="backToList()" @reloadList="backToList('reload')"></logbook-entry-detail>

	<list-component v-else id="list_container" class="list report-list logbook-entries" :definition="definition" :list="list" :showAuditRemove="auditMode && filters.audited == 1" :showInventoryAdd="!auditMode" :filters="filters" @auditRemove="removeFromAudit($event)" @inventoryAdd="iventoryAdd($event)" @refreshList="getList()" @clicked="getDetail($event)" :loading="listComponentLoading"></list-component>

	<div class="modal" v-if="showModal">
		<div class="inner">
			<h2>{{ $caplitalizeWords(modalForList) }}</h2>
			<div class="content">
				<ul v-if="modalList.length > 0" class="search-list">
					<li class="clickable-list-item" v-for="(listItem, index) in modalList" @click="assignItem(listItem)">{{ listItem.description || listItem.full_name }}</li>
				</ul>
				<div v-if="modalMessage" class="empty">{{ modalMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showModal = false">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showAuditModal">
		<div class="inner" style="max-width: inherit;">
			<h2>Multiple Results for '{{ filters.search_term }}'</h2>
			<div class="content">
				<ul v-if="auditSearchList.length > 0" class="search-list">
					<li class="clickable-list-item" v-for="(listItem, index) in auditSearchList" @click="auditThisItem(listItem)">{{ listItem.manufacturer + " " + listItem.model + " " + listItem.gun_type + " " + listItem.caliber }}</li>
				</ul>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showAuditModal = false">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showPrintModal">
		<div class="inner">
			<h2>Print List</h2>
			<div class="content">
				<p>The currently filtered list of {{ paging.total_items }} items will be output<br>to a PDF so you can print or save.</p>
				<p>Which size paper would you like?</p>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="printList('legal')">Legal</div>
				<div class="button neutral spaced" @click="printList('letter')">Letter</div>
				<div class="button cancel spaced" @click="showPrintModal = false">Cancel</div>
			</div>
		</div>
	</div>
	
	<div class="modal" v-if="showExportModal">
		<div class="inner">
			<h2>Export List</h2>
			<div class="content center">
				<p v-html="filterMessage"></p>
				<p>
					<i v-if="filters.export" class="fa fa-spinner fa-spin"></i>
					<i v-else class="fa fa-check"></i>
				</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showExportModal = false">Dismiss</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

	<help-popup :helpLink="{211:'Logbooks Search', 221:'Logbooks Filter Search', 213:'Audit Mode', 260:'Inventory a Logbook Record'}" :tours="false"></help-popup>

</div>

</template>

<script>
import ListComponent from '../components/ListComponent'
import ListDetail from '../components/ListDetail'
import ToolTip from '@/components/ToolTip.vue'
import { mapState, mapActions } from 'vuex'
import HelpPopup from '@/components/HelpPopup.vue'


export default {
	name: 'logbooks-list',
	props: ['id'],
    components: {
        'list-component': ListComponent,
        'logbook-entry-detail': ListDetail,
		'tool-tip': ToolTip,
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: true,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			listComponentLoading: false,
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
            filtersCopy:{},
			filterMessage: null,
			filterLoading: false,
			gun_types: [],
			definition: [],
			list: [],
			clientFFLNumbers: [],
			hasNonInventory: false,
			entry: {},
			paging: {},
			logbooks: {},
			fflNumberInfo: {},
			loadingFflLogBookEntries: false,
			showDetail: false,
			showModal: false,
			modalMessage: '',
			modalForList: '',
			modalList: [],
			showNewModalInput: false,
			showAuditModeTip: false,
			auditMode: false,
			auditCount: {},
			auditMessage: '',
			auditSearchList: [],
			showAuditModal: false,
			loadingAudit: false,
			showPrintModal: false,
			showExportModal: false
		}
	},
	created() {
		this.getControlLists()
	},
	computed: {
        ...mapState({
            getLogbooks: (state, getters) => getters['logbooks/getLogbooks']
        }),
		minEndDate() {
			return (this.filters.start_date) ? this.$moment(this.filters.start_date, 'YYYY-MM-DD').format('YYYY-MM-DD') : this.today().clone().format('YYYY-MM-DD')
		}
	},
	watch: {
		'$route.query': function(newRoute) {
			if (this.setFiltersFromRoute()) {
				this.getList()
			}
		}
	},
	methods: {
        ...mapActions('logbooks', [
            'updateProperty'
        ]),
		getControlLists() {
			this.apiCall({ destination: 'get_log_book_control_lists', data: { client_ffl_number_id: this.filters.client_ffl_number_id } }).then(obj => {
				if (obj.status == 'success') {
					this.updateProperty({ property: 'logbooks', value: obj.logbooks })
					this.gun_types = obj.gun_types
					this.fflNumberInfo = obj.ffl_number_info
					this.clientFFLNumbers = obj.client_ffl_numbers
					this.clearFilters(true)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList(reloadList) {
			this.showDetail = false
			let getId = this.id || this.$route.query.id
			if (getId) {
				this.$router.push('/logbooks/list')
			} else {
				if (reloadList) {
					this.getList()
					this.getAuditCount()
				} else {
					this.showPagination = true
					this.loading = false
				}
			}
		},
		getDetail(getItemId) {
			this.apiCall({ destination: 'get_item_ffl_log_book_entry', data: { ffl_log_book_entry_id: getItemId } }).then(obj => {
				this.entry = obj.entry
				this.showDetail = true
				this.showPagination = false
				this.loading = false
			}).catch(err => {
				console.log(err)
				this.loading = false
			})
		},
		today() {
			return this.$moment()
		},
		getList() {
			//if (this.loading) { return }
            this.loading = true
			this.message = 'Loading logbook records...'
			this.messageStatus = 'waiting'
			this.showDetail = false
			this.apiCall({ destination: 'get_list_ffl_log_book_entries', data: this.filters }).then(obj => {
                this.loading = false
				this.messageStatus = obj.status
				this.message = ''
				this.list = obj.list_data || []
				if (obj.definition) {
					this.definition = obj.definition
				}
				if (obj.paging) {
					this.paging = obj.paging
					this.showPagination = true
				}
				this.hasNonInventory = false
				this.list.forEach((row) => {
					if (!row.product_id) { this.hasNonInventory = true }
				})
				document.getElementById('list_container').scroll({ top: 0, behavior: 'smooth' })
			}).catch(err => {
                this.loading = false
				this.message = 'Request failed. Please check your connection and try again.'
				this.messageStatus = 'error'
				console.log(err)
			})
		},
		exportList() {
			this.showDetail = false
			this.filters.export = true
			this.filters.print = false
			this.showExportModal = true
			this.filterMessage = 'Generating export file...'
			this.apiCall({ destination: 'get_list_ffl_log_book_entries', data: this.filters }).then(obj => {
				this.filters.export = false
				// set hidden iframe src to the returned download_url
				document.getElementById("download").src = obj.download_url
				this.filterLoading = false;
				this.filterMessage  = obj.paging.total_items + ' items exported to file<br>' + obj.file_name
				this.filterMessage += '<br><br>Download didn\'t complete?<br><a href="' + obj.download_url + '" target="_blank">Click here to download...</a>'
			}).catch(err => {
				this.filters.export = false
				console.log(err)
			})
		},
		printList(size) {
            let pdfLink = this.getPDFAPIEndpoint + '?action=log_book_entries&fd_token=' + getCookie('dashboard_token') + '&size=' + size
            for (const [key, value] of Object.entries(this.filters)) {
                if (key != 'page' && key != 'log_books' && value) {
                    pdfLink += '&' + key + '=' + encodeURIComponent(value)
                }
            }
            if (this.filters.log_books) {
                pdfLink += '&log_books=' + this.filters.log_books.join(',')
            }
            window.open(pdfLink, '_blank')
            this.showPrintModal = false
        },
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		hasFilters() {
			let filterIsSet = false
			for (var property in this.filters) {
				switch (property) {
					case 'page':
					case 'source':
					case 'shopping_cart_id':
						break
					case 'log_books':
						filterIsSet = this.filters.log_books.length > 0
						break
					default:
						filterIsSet = this.filters[property] != ''
						break
				}
				if (filterIsSet) {
					return true
				}
			}
			return false
		},
		setFiltersFromRoute() {
			if (this.$route.query) {
				this.filters.on_hand = this.$route.query.on_hand || false
				this.filters.disposed = this.$route.query.disposed || false
				this.filters.is_new = this.$route.query.is_new || false
				this.filters.is_used = this.$route.query.is_used || false
				if (this.$route.query.log_books) {
					this.filters.log_books = [this.$route.query.log_books.toString()]
				}
			}
            this.filtersCopy = this.$copy(this.filters)
			return true
		},
		clearFilters(getList) {
			let currentFilters = this.$copy(this.filters)
			let currentFFLNumberId = currentFilters.client_ffl_number_id
			this.filters = {
				page: 1,
				search_term: '',
				search_select: '',
				sort_by: 'sequence_code',
				sort_order: 'desc',
				client_ffl_number_id: currentFFLNumberId,
				ffl_log_book_entry_id: '',
				log_books: [],
				on_hand: this.$route.query.on_hand || false,
				disposed: this.$route.query.disposed || false,
				is_new: this.$route.query.is_new || false,
				is_used: this.$route.query.is_used || false,
				moved_to: this.$route.query.moved_to || false,
				moved_from: this.$route.query.moved_from || false,
				include_moved: false,
				has_sales_info: false,
				not_inventory: false,
				manufacturer: '',
				manufacturer_id: '',
				gun_type: '',
				originator_contact: '',
				originator_contact_id: '',
				disposal_contact: '',
				disposal_contact_id: '',
				start_date: '',
				end_date: '',
				log_books: this.$route.query.log_books ? [this.$route.query.log_books.toString()] : []
			}
			if (this.clientFFLNumbers.length > 0 && !this.filters.client_ffl_number_id) {
				this.filters.client_ffl_number_id = this.clientFFLNumbers[0].client_ffl_number_id
			}

			let getId = this.id || this.$route.query.id
			if (getId) {
				this.getDetail(getId)
			} else if (getList) {
				this.getList()
			}
		},
		logbookInFilter(logbookId) {
			if (logbookId && this.filters.log_books) {
				return this.filters.log_books.indexOf(logbookId.toString()) > -1
			} else {
				return true
			}
		},
		toggleFilter(which) {
			// use_date_received and use_date_disposed are disabled without start or end date
			if (which == 'use_date_received' || which == 'use_date_disposed') {
				if (!this.filters.start_date && !this.filters.end_date) {
					return false;
				}
				if (which == 'use_date_received') {
					this.filters.use_date_disposed = false
				} else {
					this.filters.use_date_received = false
				}
			}
			if (which == 'on_hand') {
				this.filters.disposed = false
				this.filters.not_inventory = false
			}
			if (which == 'disposed') {
				this.filters.on_hand = false
			}
			if (which == 'is_used') {
				this.filters.is_new = false
			}
			if (which == 'is_new') {
				this.filters.is_used = false
			}
			if (which == 'has_sales_info') {
				this.filters.on_hand = true
				this.filters.disposed = false
				this.filters.audited = false
			}
			if (which == 'not_inventory') {
				this.filters.on_hand = true
				this.filters.disposed = false
				this.filters.audited = false
			}
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		doSearch() {
			if (this.filters.search_term == '') { 
				this.filters.include_moved = false
			} else {
				this.filters.include_moved = true
			}
			this.filters.page = 1
			this.getList()
		},
		doSearchSelect() {
			if (this.filters.search_term === '') {
				return
			}
			this.doSearch();
		},
		setFilterDates() {
			this.filters.page = 1
			this.getList()
		},
		setLogbookFilter(logbookId, exclusive) {
			if (exclusive) {
				this.filters.log_books = []
			}
			if (this.logbookInFilter(logbookId)) {
				var index = this.filters.log_books.indexOf(logbookId.toString());
				this.filters.log_books.splice(index, 1);
			} else {
				this.filters.log_books.push(logbookId.toString())
			}
			this.filters.page = 1
			this.getList()
			if (this.auditMode) {
				this.getAuditCount()
			}
		},
		getFilterList(listFor) {
			// NOTE: converting these to straight searches
			if (!this.filters[listFor]) { return false }
			this.filters.page = 1
			this.getList()
		},
		assignItem(listItem) {
			this.filters[this.modalForList + '_id'] = listItem[this.modalForList + '_id'] || listItem['contact_id']
			this.filters[this.modalForList] = listItem.description || listItem.full_name
			this.showModal = false
			this.modalList = []
			this.modalTitle = ''
			this.modalForList = ''
			this.filters.page = 1
			this.getList()
		},
		setAuditMode() {
			this.clearFilters(false)
			if (!this.filters.audit_date) {
				this.filters.audit_date = this.$today().clone().format('YYYY-MM-DD')
			}
			this.filters.on_hand = 1
			this.filters.audited = 1
			this.auditMode = true
			this.getList()
			this.getAuditCount()
		},
		setSearchMode() {
			this.auditMode = false
			this.clearFilters(true)
		},
		doAudit() {
			if (this.loadingAudit) { return false }
			this.entry = {}
			this.showDetail = false
			this.auditMessage = ''
			this.loadingAudit = true
			this.apiCall({ destination: 'audit_serial_number', data: { search_term: this.filters.search_term, ffl_log_book_entry_id: this.filters.ffl_log_book_entry_id, audit_date: this.filters.audit_date, log_books: this.filters.log_books } }).then(obj => {
				this.loadingAudit = false
				this.auditMessage = obj.message
				if (obj.search_list && obj.search_list.length > 1) {
					this.auditSearchList = obj.search_list
					this.showAuditModal = true
				} else if (obj.status == 'success') {
					this.filters.search_term = ''
					this.filters.ffl_log_book_entry_id = ''
					this.getList()
					var timer = setTimeout((function() {
						this.auditMessage = ''
					}.bind(this)),3000)
					this.getAuditCount()
				}
			}).catch(err => {
				console.log(err)
			})
		},
		auditThisItem(item) {
			this.filters.ffl_log_book_entry_id = item.ffl_log_book_entry_id
			this.doAudit()
			this.showAuditModal = false
		},
		removeFromAudit(fflLogBookEntryId) {
			if (this.listComponentLoading) { return }
			this.auditMessage = 'Removing...'
			this.listComponentLoading = true
			this.apiCall({ destination: 'audit_serial_number', data: { ffl_log_book_entry_id: fflLogBookEntryId, audit_date: this.filters.audit_date, remove: 1 } }).then(obj => {
				var timer = setTimeout((function() {
					this.listComponentLoading = false
					this.getList()
					this.getAuditCount()
					this.auditMessage = obj.message
				}.bind(this)), 1000)
			}).catch(err => {
				console.log(err)
			})
		},
		getAuditCount() {
			this.apiCall({ destination: 'get_audit_count', data: { audit_date: this.filters.audit_date, log_books: this.filters.log_books } }).then(obj => {
				this.auditCount = obj.audit_count
			}).catch(err => {
				console.log(err)
			})
		},
		iventoryAdd(fflLogBookEntryId) {
			this.$router.push('/logbooks/receive?ffl_log_book_entry_id=' + fflLogBookEntryId)
		},
		doPrint() {
			if (this.loading) { return false }
        	this.loading = true
			this.apiCall({ destination: 'get_item_ffl_log_book_entry', data: { ffl_log_book_entry_id: this.entry.ffl_log_book_entry_id, print: true } }).then(obj => {
        		this.loading = false
				if (obj.pdf_url) {
                	window.open(obj.pdf_url)
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
        		this.loading = false
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
	.logbooks-list {
		position: relative;
		grid-template-columns: 250px 1fr;
		&.filters-closed {
			overflow-y: initial;
			grid-template-columns: 1fr !important;
		}
	}
}

.logbook-entries {
	&.filters-closing {
		transition: 0.3s ease;
		transform: translateX(-250px);
	}
}

.close-filters {
	cursor: pointer;
	position: absolute;
	font-size: 1.25em;
	top: 0.33rem;
	left: -1.5rem;
}

// slide-right
.slide-enter-active, .slide-leave-active {
	transition: 0.3s ease; //cubic-bezier(.47,.23,.27,1.41);
}
.slide-enter, .slide-leave-to {
	transform: translate(-100%, 0);
}
</style>
